
import { createSlice } from '@reduxjs/toolkit';

export const GetNotificationSlice = createSlice({
  name: 'getNotification',
  initialState: {
    getNotification: [],
  },
  reducers: {
    GET_NOTIFICATION_REQUEST: (state) => {
      state.loading = true;
      // Keep the previous list while refetching so mark-as-read / socket refresh
      // does not wipe tab badges and the header count back to 0 mid-request.
    },
    GET_NOTIFICATION_SUCCESS: (state, action) => {
      state.loading = false;
      state.getNotification = action.payload;
    },
    GET_NOTIFICATION_FAIL: (state, action) => {
      state.loading = false;
      state.getNotification = action.payload;
    },
  },
});

export const { GET_NOTIFICATION_REQUEST, GET_NOTIFICATION_SUCCESS, GET_NOTIFICATION_FAIL } = GetNotificationSlice.actions;
export default GetNotificationSlice.reducer;




